export enum TransferStatus {
  Draft = 'draft',
  Pending = 'pending',
  Completed = 'completed',
  Incidence = 'incidence',
  Resolved = 'resolved',
}
